
import React, { useState } from "react";
import { TextField, Button, Box, Typography, Stepper, Step, StepLabel } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { createMainRoot } from "../../services/apiService";

const steps = ["البيانات العامة", "الفروع", "الطاولات", "الخزن", "المطابخ"];

const Branches = () => {

  const [branchData, setBranchData] = useState({
    name: "الفرع الرئيسي",
    address: "العنوان",
  });

  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setBranchData({ ...branchData, [e.target.name]: e.target.value });
  };

 const handleCreateBranch = async () => {
  if (!branchData.name || !branchData.address) {
    setError("❌ يجب إدخال اسم الفرع والعنوان.");
    return;
  }
    try {
      const response = await createMainRoot(branchData.name, branchData.address);
      setSuccessMessage(response.message);
      setError(null);

      setTimeout(() => navigate("/setup/tables"), 0);
    } catch (err) {
      setError(err.message);
      setSuccessMessage("");
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: "auto", mt: 5, p: 4, boxShadow: 3, borderRadius: 2 }}>
      <Stepper activeStep={1} alternativeLabel sx={{ mb: 4 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', textAlign: 'center' }}>
        تعريف بيانات الفرع
      </Typography>

      <TextField
        label="اسم الفرع"
        name="name"
        fullWidth
        value={branchData.name}
        onChange={handleChange}
        sx={{ mb: 2 }}
      />

      <TextField
        label="عنوان الفرع"
        name="address"
        fullWidth
        value={branchData.address}
        onChange={handleChange}
        sx={{ mb: 2 }}
      />

      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" color="primary" onClick={handleCreateBranch}>
          التالي
        </Button>
      </Box>

      {successMessage && (
        <Typography color="success.main" sx={{ mt: 2 }}>
          {successMessage}
        </Typography>
      )}

      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default Branches;








// // التنسيق
// import React, { useState } from "react";
// import { 
//   TextField, Button, Box, Typography, Stepper, Step, StepLabel, 
//   useMediaQuery, useTheme, Paper, Container 
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { createMainRoot } from "../../services/apiService";

// const steps = ["البيانات العامة", "الفروع", "الطاولات", "الخزن", "المطابخ"];

// const Branches = () => {
//   const theme = useTheme();
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // ✅ دعم الشاشات الصغيرة
//   const isTablet = useMediaQuery(theme.breakpoints.down("md")); // ✅ دعم الأجهزة اللوحية

//   const [branchData, setBranchData] = useState({
//     name: "الفرع الرئيسي",
//     address: "العنوان",
//   });

//   const [errors, setErrors] = useState({ name: false, address: false });
//   const [successMessage, setSuccessMessage] = useState("");
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     setBranchData({ ...branchData, [e.target.name]: e.target.value });
//     setErrors({ ...errors, [e.target.name]: false });
//   };

//   const handleCreateBranch = async () => {
//     let newErrors = { name: !branchData.name, address: !branchData.address };
//     setErrors(newErrors);

//     if (newErrors.name || newErrors.address) return;

//     try {
//       const response = await createMainRoot(branchData.name, branchData.address);
//       setSuccessMessage(response.message);
//     } catch (err) {
//       setErrors({ ...errors, api: err.message });
//     }
//   };

//   return (
//     <Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
//       <Paper elevation={3} sx={{ p: 4, borderRadius: 3, boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)" }}>
//         {/* ✅ تحسين الخطوات لتكون متجاوبة */}
//         <Stepper activeStep={1} alternativeLabel={!isSmallScreen} sx={{ mb: 4 }}>
//           {steps.map((label) => (
//             <Step key={label}>
//               <StepLabel>
//                 {!isTablet ? label : null} {/* ✅ إخفاء العناوين على الجوال */}
//               </StepLabel>
//             </Step>
//           ))}
//         </Stepper>

//         <Typography 
//           variant={isSmallScreen ? "h6" : "h5"} 
//           sx={{ mb: 3, fontWeight: "bold", textAlign: "center", color: theme.palette.primary.main }}
//         >
//           تعريف بيانات الفرع
//         </Typography>

//         {/* ✅ تصميم متجاوب لحقل إدخال البيانات */}
//         <TextField
//           label="اسم الفرع"
//           name="name"
//           fullWidth
//           value={branchData.name}
//           onChange={handleChange}
//           error={errors.name}
//           helperText={errors.name ? "يجب إدخال اسم الفرع" : ""}
//           sx={{ mb: 2 }}
//         />

//         <TextField
//           label="عنوان الفرع"
//           name="address"
//           fullWidth
//           value={branchData.address}
//           onChange={handleChange}
//           error={errors.address}
//           helperText={errors.address ? "يجب إدخال العنوان" : ""}
//           sx={{ mb: 2 }}
//         />

//         {/* ✅ تحسين الأزرار وجعلها متوافقة مع جميع الشاشات */}
//         <Box sx={{ display: "flex", justifyContent: "space-between", flexDirection: isSmallScreen ? "column" : "row", gap: 2 }}>
//           <Button 
//             variant="outlined" 
//             color="secondary" 
//             onClick={() => navigate("/setup/general")}
//             fullWidth={isSmallScreen} 
//           >
//             السابق
//           </Button>

//           <Button 
//             variant="contained" 
//             color="primary" 
//             onClick={handleCreateBranch} 
//             disabled={!branchData.name || !branchData.address}
//             fullWidth={isSmallScreen} 
//           >
//             التالي
//           </Button>
//         </Box>

//         {/* ✅ تحسين رسائل الخطأ والنجاح */}
//         {successMessage && (
//           <Typography color="success.main" sx={{ mt: 3, textAlign: "center", fontSize: "16px" }}>
//             ✅ {successMessage}
//             <Button onClick={() => navigate("/setup/tables")} sx={{ ml: 2 }}>
//               المتابعة
//             </Button>
//           </Typography>
//         )}

//         {errors.api && (
//           <Typography color="error" sx={{ mt: 2, textAlign: "center", fontSize: "16px" }}>
//             ❌ {errors.api}
//           </Typography>
//         )}
//       </Paper>
//     </Container>
//   );
// };

// export default Branches;
